import { render } from "./Release.vue?vue&type=template&id=033e75dd"
import script from "./Release.vue?vue&type=script&lang=js"
export * from "./Release.vue?vue&type=script&lang=js"

import exportComponent from "/home/builder/shared-storage/.project-directory/builder-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__